/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class TeacherCalendar extends Sv {
    constructor() {
        super();
        this.baseUrl += '/teacherCalendar';
    }

    data({
        teacherName,
        tel,
        beginTime,
        endTime,
        isAvailable,
        teacherCalendarType,
        remarks,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            teacherName,
            tel,
            beginTime,
            endTime,
            isAvailable,
            teacherCalendarType,
            remarks,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, beginTime, endTime, isAvailable, teacherCalendarType, certCatId, remarks, teacherIds } = {}) {
        return super.post('/save', {
            id,
            beginTime,
            endTime,
            isAvailable,
            teacherCalendarType,
            certCatId,
            remarks,
            teacherIds,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    teacherCalendarStat({ statDate, teacherName, teacherCalendarType, certCatId, currentPage, pageSize }) {
        let statDateBegin = null;
        let statDateEnd = null;
        if (statDate != null && statDate.length === 2) {
            [statDateBegin, statDateEnd] = statDate;
        }
        return super.get('/teacherCalendarStat', {
            statDateBegin,
            statDateEnd,
            teacherName,
            teacherCalendarType,
            certCatId,
            currentPage,
            pageSize,
        });
    }
}

export default new TeacherCalendar();
export { TeacherCalendar };
